module.exports = __webpack_public_path__ + "static/media/6.f5520e14.png";